<template>
  <div class="home">
    <div class="breadcrumb">
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item :to="{ path: '/' }">
          <i class="el-icon-s-home"></i>
        </el-breadcrumb-item>
        <el-breadcrumb-item>{{
          getTitle('header.booking')
        }}</el-breadcrumb-item>
        <el-breadcrumb-item>{{ getTitle('header.ticket') }}</el-breadcrumb-item>
      </el-breadcrumb>
    </div>
    <div
      class="banner"
      :style="{ backgroundImage: 'url(' + advertInfo.advert_image + ')' }"
    ></div>
    <div class="public-w date-box">
      <el-carousel arrow="always" :autoplay="false" :loop="false">
        <el-carousel-item v-for="(item, index) in childDateList" :key="index">
          <div
            :class="
              dateIndex == currentIndex && currentItemIndex == index
                ? 'data-item active'
                : 'data-item'
            "
            v-for="(dateItem, dateIndex) in item"
            :key="dateIndex"
            @click="dateClick(dateIndex, index)"
          >
            <div class="time">{{ dateItem.date }}</div>
            <div class="week">{{ getTitle('ticket.' + dateItem.weekDay) }}</div>
          </div>
        </el-carousel-item>
      </el-carousel>
    </div>
    <div class="public-w ticket-list">
      <el-row :gutter="20">
        <el-col
          :span="6"
          v-for="(intervalItem, intervalIndex) in dateIntervalList"
          :key="intervalIndex"
        >
          <div class="ticket-item">
            <div class="fl">
              <div class="time">
                {{ intervalItem.start_time }}-{{ intervalItem.end_time }}
              </div>
              <div class="more">
                {{ getTitle('ticket.surplus') }}
                <span>{{ intervalItem.number }}</span>
              </div>
            </div>
            <div class="fr" @click="toBuyTicket(intervalItem)">
              <span class="btn">{{ getTitle('ticket.buy') }}</span>
            </div>
          </div>
        </el-col>
      </el-row>
    </div>
    <div class="public-w tab-box">
      <div class="tab-title" :class="[isFixed ? 'isFixed' : '']">
        <div class="active">{{ content01[0] ? content01[0].title : '' }}</div>
        <div>{{ content02[0] ? content02[0].title : '' }}</div>
        <div>{{ content03[0] ? content03[0].title : '' }}</div>
        <div>{{ content04[0] ? content04[0].title : '' }}</div>
        <div>{{ content05[0] ? content05[0].title : '' }}</div>
        <div>{{ content06[0] ? content06[0].title : '' }}</div>
        <div>{{ content07[0] ? content07[0].title : '' }}</div>
      </div>
      <div class="tab-text">
        <div class="tab-item">
          <div class="title">{{ content01[0] ? content01[0].title : '' }}</div>
          <div
            class="text"
            v-html="content01[0] ? content01[0].content : ''"
          ></div>
        </div>
        <div class="tab-item">
          <div class="title">{{ content02[0] ? content02[0].title : '' }}</div>
          <div
            class="text"
            v-html="content02[0] ? content02[0].content : ''"
          ></div>
        </div>
        <div class="tab-item">
          <div class="title">{{ content03[0] ? content03[0].title : '' }}</div>
          <div
            class="text"
            v-html="content03[0] ? content03[0].content : ''"
          ></div>
        </div>
        <div class="tab-item">
          <div class="title">{{ content04[0] ? content04[0].title : '' }}</div>
          <div
            class="text"
            v-html="content04[0] ? content04[0].content : ''"
          ></div>
        </div>
        <div class="tab-item">
          <div class="title">{{ content05[0] ? content05[0].title : '' }}</div>
          <div
            class="text"
            v-html="content05[0] ? content05[0].content : ''"
          ></div>
        </div>
        <div class="tab-item">
          <div class="title">{{ content06[0] ? content06[0].title : '' }}</div>
          <div
            class="text"
            v-html="content06[0] ? content06[0].content : ''"
          ></div>
        </div>
        <div class="tab-item">
          <div class="title">{{ content07[0] ? content07[0].title : '' }}</div>
          <div
            class="text"
            v-html="content07[0] ? content07[0].content : ''"
          ></div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { setLocaleToPath, loadLanguageAsync } from '@/setup/i18n';
import $ from 'jquery';
import www from '../../api/www';
import info from '../../api/info';
import moment from 'moment';
import routerTo from '@/router/routerTo';
import { mapMutations, mapState } from 'vuex';
import _ from 'underscore';
export default {
  data() {
    return {
      advertInfo: {},
      isFixed: false,
      tabTitleScrollTop: null,
      scrolltop: null,
      topList: [],
      adList: [],
      contentList: [],
      scenicInfo: {},
      restTickets: [],
      dateList: [], //日期选择
      dateIntervalList: [], //选择完日期后的区间显示
      currentIndex: 0,
      currentItemIndex: 0,
      customerType: [], //优惠类型
      weekShow: [
        '星期一',
        '星期二',
        '星期三',
        '星期四',
        '星期五',
        '星期六',
        '星期日',
      ],
    };
  },
  computed: {
    locale() {
      return this.$store.state.locale;
    },
    ...mapState({
      isLogin: (state) => state.isLogin,
    }),
    childDateList() {
      const childDateList = [];
      this.dateList.forEach((item, index) => {
        const page = Math.floor(index / 7);
        if (!childDateList[page]) {
          childDateList[page] = [];
        }
        childDateList[page].push(item);
      });
      return childDateList;
    },
    /*
    isLogin() {
      return this.$store.getters.isLogin;
    },*/
    content01() {
      return this.localeContent01(this.locale);
    },
    content02() {
      return this.localeContent02(this.locale);
    },
    content03() {
      return this.localeContent03(this.locale);
    },
    content04() {
      return this.localeContent04(this.locale);
    },
    content05() {
      return this.localeContent05(this.locale);
    },
    content06() {
      return this.localeContent06(this.locale);
    },
    content07() {
      return this.localeContent07(this.locale);
    },
  },
  mounted() {
    this.tabInit();
    this.$store.commit('delecteContact', null);
  },
  created() {
    this.$store.commit('setLocale', this.$i18n.locale); // 触发指定默认语言
    /*this.getAD();//获取首页广告*/
    this.getAdvertInfo();
    this.getRestTickets();
    this.getScenicArea();
    this.getContentList();
  },
  destroyed() {
    // 注意，如果离开该页面需要移除这个监听的事件，不然会报错。
    window.removeEventListener('scroll', this.handleScroll);
  },
  methods: {
    getTitle(name) {
      loadLanguageAsync(this.locale);
      return this.$t(`${name}.title`);
    },
    tabInit() {
      // 滚动条添加监听
      window.addEventListener('scroll', this.handleScroll);
      //tab title 默认距离高度，超过之后悬浮
      this.tabTitleScrollTop = $('.tab-title').offset().top + 65;
      // 获取每块内容到顶部距离
      let that = this;
      $('.tab-item').each(function() {
        that.topList.push($(this).offset().top - 60);
      });
      //tab title添加点击事件
      $('.tab-title div').on('click', function() {
        $('.tab-title div').removeClass('active');
        $(this).addClass('active');
        let index = $(this).index();
        $(document).scrollTop(that.topList[index]);
      });
    },
    async getAdvertInfo() {
      const advertInfoInfo = await www.getAdvertInfo({
        advert_id: '1',
        merchant_code: process.env.VUE_APP_MERCHANT_CODE, //TODO
      });
      this.advertInfo = advertInfoInfo;
    },
    async getAD() {
      let prarams = {
        merchant_code: '120441', //商户ID //TODO
        ad_type: 'app', //广告类型（app/app_home）
      };
      const ads = await info.getAd(prarams);
      this.adList = ads;
    },
    async getRestTickets() {
      const restTickets = await info.getRestTickets({
        // place_code: "S0028151",//TODO
        marketing_code: process.env.VUE_APP_MERCHANT_CODE,
      });
      this.restTickets = restTickets;
      let dates = Object.keys(restTickets[0].tickets);
      let that = this;
      dates.forEach((item, index) => {
        let dateNew = that.formatDate(item);
        let countNum = that.getTicketsCount(item);
        if (index == 0) {
          that.curDate = item;
          that.dateIntervalList = that.restTickets[0].tickets[item];
        }
        var weekOfday = moment(item, 'YYYY-MM-DD').format('E');
        that.dateList.push({
          date: dateNew,
          count: countNum,
          originDate: item,
          weekDay: this.weekShow[weekOfday - 1],
        });
      });
    },
    //获取景区列表
    async getScenicArea() {
      const scenicArea = await info.getScenicArea({
        // place_code: "S0028151",//TODO
      });
      let that = this;
      this.customerType = scenicArea[0].customer_type;
      localStorage.setItem('customerType', JSON.stringify(this.customerType));
      // console.log('优惠类型是', this.customerType);
      if (scenicArea.length > 0) {
        that.scenicInfo = scenicArea[0];
        //客服电话
        localStorage.setItem('service_phone', that.scenicInfo.service_phone);
        //是否能够退票
        if (
          Object.prototype.hasOwnProperty.call(that.scenicInfo, 'can_refund')
        ) {
          // console.log('哈哈哈哈哼哼', that.scenicInfo);
          let can_refund = that.scenicInfo.can_refund
            ? that.scenicInfo.can_refund
            : 0;
          localStorage.setItem('can_refund', can_refund);
        }
      }
      scenicArea.forEach(function(item, index) {
        item.pics_info.forEach((picInfo) => {
          if (picInfo.type == 's') {
            item.pic_s_url = picInfo.name;
            item.pic_s_name = picInfo.pic_name;
          } else if (picInfo.type == 'm') {
            item.pic_m_url = picInfo.name;
            item.pic_m_name = picInfo.pic_name;
          } else if (picInfo.type == 'l') {
            item.pic_l_url = picInfo.name;
            item.pic_l_name = picInfo.pic_name;
          }
        });
      });
    },
    dateClick(dateIndex, cIndex) {
      //日期选择
      this.currentIndex = dateIndex;
      this.currentItemIndex = cIndex;
      let dateItem = this.dateList[dateIndex];
      this.curDate = dateItem.originDate;
      this.dateIntervalList = this.restTickets[0].tickets[dateItem.originDate];
    },
    toBuyTicket(ticketInfo) {
      console.log('ticket信息', ticketInfo);
      let prarams = {
        palceCode: this.restTickets[0].code,
        startTime: ticketInfo.start_time,
        endTime: ticketInfo.end_time,
        currentDate: this.curDate,
        ticketCount: ticketInfo.number,
        ticketsNotes: this.scenicInfo.notes, //购票须知
      };
      if (!this.isLogin) {
        routerTo.toLogin(this.$router, false, prarams);
        return;
      }
      //立即购买
      routerTo.toBuyTicket(this.$router, false, prarams);
    },
    formatDate(date) {
      let newDate = new Date(date);
      let month =
        newDate.getMonth() + 1 < 10
          ? '0' + (newDate.getMonth() + 1)
          : newDate.getMonth() + 1;
      let day =
        newDate.getDate() < 10 ? '0' + newDate.getDate() : newDate.getDate();
      return month + '-' + day;
    },
    getTicketsCount(key) {
      let tickets = this.restTickets[0].tickets[key];
      let total = 0;
      for (let i = 0; i < tickets.length; i++) {
        let ticket = tickets[i];
        total += ticket.number;
      }
      return total;
    },
    handleScroll() {
      let scrollTop =
        window.pageYOffset ||
        document.documentElement.scrollTop ||
        document.body.scrollTop;

      if (scrollTop >= this.tabTitleScrollTop) {
        this.isFixed = true;
        this.topList.forEach((item, index) => {
          let len = this.topList.length;
          let next = index < len;
          if (next) {
            if (
              (scrollTop > item && scrollTop < this.topList[index + 1]) ||
              scrollTop > this.topList[len - 1]
            ) {
              $('.tab-title div').removeClass('active');
              $('.tab-title div')
                .eq(index)
                .addClass('active');
            }
          }
        });
      } else {
        this.isFixed = false;
      }
    },
    async getContentList() {
      const getContentList = await www.getContentList({
        merchant_code: process.env.VUE_APP_MERCHANT_CODE,
        status: 'publish',
        category: '7',
        page_size: '100',
      });
      this.contentList = getContentList.data;
    },
    localeContent01(locale) {
      return _.filter(this.contentList, (cur) => {
        return (
          cur.country_code === (locale === 'zh-cmn-Hans' ? 'zh' : locale) &&
          cur.title === this.$t('ticket.explain.title')
        );
      });
    },
    localeContent02(locale) {
      return _.filter(this.contentList, (cur) => {
        return (
          cur.country_code === (locale === 'zh-cmn-Hans' ? 'zh' : locale) &&
          cur.title === this.$t('ticket.openingHours.title')
        );
      });
    },
    localeContent03(locale) {
      return _.filter(this.contentList, (cur) => {
        return (
          cur.country_code === (locale === 'zh-cmn-Hans' ? 'zh' : locale) &&
          cur.title === this.$t('ticket.refund.title')
        );
      });
    },
    localeContent04(locale) {
      return _.filter(this.contentList, (cur) => {
        return (
          cur.country_code === (locale === 'zh-cmn-Hans' ? 'zh' : locale) &&
          cur.title === this.$t('ticket.check.title')
        );
      });
    },
    localeContent05(locale) {
      return _.filter(this.contentList, (cur) => {
        return (
          cur.country_code === (locale === 'zh-cmn-Hans' ? 'zh' : locale) &&
          cur.title === this.$t('ticket.invoice.title')
        );
      });
    },
    localeContent06(locale) {
      return _.filter(this.contentList, (cur) => {
        return (
          cur.country_code === (locale === 'zh-cmn-Hans' ? 'zh' : locale) &&
          cur.title === this.$t('ticket.policy.title')
        );
      });
    },
    localeContent07(locale) {
      return _.filter(this.contentList, (cur) => {
        return (
          cur.country_code === (locale === 'zh-cmn-Hans' ? 'zh' : locale) &&
          cur.title === this.$t('ticket.statement.title')
        );
      });
    },
  },
};
</script>
<style scoped lang="less">
.public-w {
  background-color: transparent;
}
.date-box {
  margin-bottom: 16px;
  padding-top: 20px;
  border-radius: 16px;
  background-color: #fff;
  .el-carousel {
    margin: 0 auto;
  }
  /deep/.el-carousel__container {
    width: 770px;
    height: 72px;
    margin: 0 auto;
  }
  /deep/.el-carousel__arrow--left {
    top: 35%;
    left: -80px !important;
  }
  /deep/.el-carousel__arrow--right {
    top: 35%;
    right: -80px !important;
  }
  .el-carousel__item {
    display: flex;
    /*justify-content: space-around;*/
    .data-item {
      width: 110px;
      border-bottom: 3px solid #fff;
      text-align: center;
      cursor: pointer;
      .time {
        margin-bottom: 8px;
        color: #515457;
        font-size: 20px;
      }
      .week {
        color: #9e9e9e;
        font-size: 14px;
      }
    }
    .active {
      border-bottom-color: #31a775;
      .time {
        color: #31a775;
      }
      .week {
        color: #31a775;
      }
    }
  }
}
.ticket-list {
  margin-bottom: 24px;
  .ticket-item {
    display: flex;
    justify-content: space-between;
    margin-bottom: 16px;
    padding: 24px;
    border-radius: 8px;
    background-color: #fff;
    cursor: pointer;
    .time {
      margin-bottom: 8px;
      color: #191b26;
      font-size: 20px;
      line-height: 20px;
    }
    .more {
      color: #515457;
      font-size: 16px;
      text-align: left;
      span {
        margin-left: 8px;
        color: #f15b4a;
        font-weight: bold;
        font-size: 20px;
      }
    }
    .btn {
      display: inline-block;
      width: 88px;
      height: 28px;
      margin-top: 8px;
      border-radius: 16px;
      color: #fff;
      line-height: 28px;
      text-align: center;
      background-color: #31a775;
      box-shadow: 0 2px 6px 0 rgba(2, 190, 110, 0.1);
    }
  }
}
.tab-box {
  margin-bottom: 64px;
  background-color: #fff;
  .tab-title {
    height: 71px;
    padding: 0 40px 1px;
    border-bottom: 1px solid #eeeeee;
    border-radius: 8px 8px 0 0;
    text-align: left;
    div {
      display: inline-block;
      margin-right: 40px;
      border-bottom: 3px solid #fff;
      color: #191b26;
      font-size: 18px;
      line-height: 67px;
      cursor: pointer;
    }
    .active {
      border-color: #31a775;
      color: #31a775;
    }
  }
  .tab-text {
    padding: 40px;
    text-align: left;
    .tab-item {
      margin-bottom: 40px;
      color: #191b26;
      font-size: 16px;
      .title {
        margin-bottom: 24px;
        padding-left: 10px;
        border-left: 4px solid #31a775;
        font-size: 18px;
        line-height: 24px;
      }
      .text {
        color: #191b26;
        line-height: 32px;
        img {
          display: block;
          margin: 0 auto;
        }
      }
      .flex {
        display: flex;
        justify-content: space-between;
      }
    }
  }
  .isFixed {
    width: 1100px;
    position: fixed;
    top: 0;
    z-index: 999;
    background-color: #fff;
  }
}
.table-data-a {
  width: 600px;
  margin: 0 auto 20px;
  border-collapse: collapse;
  font-size: 14px;
  line-height: 22px;
  caption {
    font-weight: bold;
    line-height: 30px;
    text-align: left;
  }
  thead th {
    padding: 5px 10px;
    border: 1px solid #fff;
    color: #fff;
    text-align: center;
    background: #4f81bd;
  }
  tbody td {
    padding: 5px 10px;
    border: 1px solid #fff;
    text-align: center;
    background: #c6d9f1;
  }
}
.table-data-b {
  width: 600px;
  margin: 0 auto;
  border-collapse: collapse;
  font-size: 14px;
  line-height: 22px;
  caption {
    font-weight: bold;
    line-height: 30px;
    text-align: left;
  }
  thead th {
    padding: 5px 10px;
    border: 1px solid #fff;
    color: #fff;
    text-align: center;
    background: #76923c;
  }
  tbody td {
    padding: 5px 10px;
    border: 1px solid #fff;
    text-align: center;
    background: #eaf1dd;
  }
}
</style>
